import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock } = FiIcons;

export default function ExploreCard({ page }) {
  return (
    <motion.div 
      whileHover={{ y: -5 }}
      className="glass-card p-8 group hover:border-white/20 transition-all"
    >
      <Link to={`/${page.username}`} className="block">
        <div className="flex items-center space-x-4 mb-6">
          <div className="w-14 h-14 bg-white/5 rounded-2xl flex items-center justify-center text-white group-hover:bg-primary transition-colors">
            <SafeIcon icon={page.icon} className="w-7 h-7" />
          </div>
          <div>
            <h3 className="text-lg font-black text-white tracking-tighter uppercase italic">@{page.username}</h3>
            <p className="text-sm text-slate-500 font-medium">{page.descriptor}</p>
          </div>
        </div>
        
        <div className="p-4 bg-white/5 rounded-2xl mb-6">
          <p className="text-sm text-slate-400 italic">"{page.recentWork}"</p>
        </div>

        <div className="flex items-center justify-between text-[10px] font-black uppercase tracking-widest text-slate-600">
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiClock} className="w-3 h-3" />
            <span>{page.lastActive}</span>
          </div>
          <span className="text-white group-hover:text-primary transition-colors">View Page →</span>
        </div>
      </Link>
    </motion.div>
  );
}